$(function () {
  $("#promoBtn").on("click", function () {
    $("#modal-promo").addClass("active");
  });

  $("#signupBtn").on("click", function () {
    $("#modal-signup").addClass("active");
  });

  $("#forgotPasswordBtn").on("click", function () {
    $("#modal-forgot-password").addClass("active");
  });

  $("#forgotPasswordBtn").on("mouseenter", function () {
    $(this).siblings(".tag").removeClass("hide");
  });

  $("#forgotPasswordBtn").on("mouseleave", function () {
    $(this).siblings(".tag").addClass("hide");
  });

  $(".modal-close, .modal-user-form .modal-container__form .submit-success .button-confirm").on("click", function () {
    $(this).parents("modal").removeClass("active");
  });

  $("#signUpSubmitButton").on("click", function () {
    $("#registerFormWithGroupError button[type='submit']").trigger("click");
  });

  $("#loginForm .input-wrapper .login-password").on("keypress", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      $("#loginBtn").trigger("click");
    }
  });

  if (window.location.pathname.split("/").pop() === "register.html") {
    $("#modal-signup").addClass("active");
    $("#modal-signup .modal-container .modal-close").hide();
  }
});

// Date timer
$(function () {
  setInterval(updateTime, 1000);
  function updateTime() {
    var date = new Date().toLocaleString("en-US", { hour12: false }).split(" ");
    var time = date[1];
    var mdy = date[0];
    mdy = mdy.split("/");
    var month = parseInt(mdy[0]);
    var day = parseInt(mdy[1]);
    var year = parseInt(mdy[2]);
    var formattedDate = `${year}-${month}-${day} ${time} `;

    $(".timenow").text(formattedDate);
  }
  updateTime();
});

$("#profileName").on("click", () => {
  const dropdown = $(".post-login-dropdown");
  const dropdownIcon = $("#profileName").find(".dropdown-chevron");

  if (dropdown.hasClass("hide")) {
    dropdown.removeClass("hide");
    console.log(dropdownIcon);
    dropdownIcon.addClass("opened");
  } else {
    dropdown.addClass("hide");
    dropdownIcon.removeClass("opened");
  }
});
